import {DataEntryModel} from './data-entry.model';
import {Store} from '../data/store';

export class DataEntryCollection
{
    protected _data : DataEntryModel[];

    constructor() {
        this._data = [];
    }

    public addObject(countryCode : string, transaction: number) : DataEntryCollection {

        let object : DataEntryModel = (new DataEntryModel(countryCode, transaction)).init();

        if(!object)
            return this;

        this._data.push(object);

        this._registerLifespan(object);

        return this;
    }

    public get data() : DataEntryModel[]{
        return this._data;
    }

    protected _registerLifespan(object : DataEntryModel) : void
    {
        let duration = 6000; // implement time logic ?

        setTimeout(() => {
            object.deactivate().then(() => {
                this._data.splice(
                    this._data.indexOf(object), 1
                );
            })
        }, duration)
    }

    public play() : void
    {
        setTimeout(() => {
            let country = Store.COUNTRIES[Math.floor(Math.random() * 100)];
            this.addObject(country.code, (Math.random()) * 100000);
            console.log(country)
            this.play();
        }, 2500)
    }
}



// WEBPACK FOOTER //
// ./src/app/components/charts/chart/map-chart/model/data-entry-collection.ts